import React, { useState, useEffect } from "react";
import api from "../../api/api";
import "../../css/Meeting.css";
import "../../css/Myorder.css";
import { useNavigate } from "react-router-dom";

const Myorder = () => {
  const [username, setUsername] = useState("");
  const [empId, setEmpId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");
  const [roles, setRoles] = useState([
    "Dealer",
    "Sub Dealer",
    "Farmer",
    "Distributor",
    "Salar",
  ]);
  const [textInput, setTextInput] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showPopular, setShowPopular] = useState(true);

  // 🔽 New states for state, distributor, and address
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [distributors, setDistributors] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState("");
  const [distributorAddress, setDistributorAddress] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const empId = localStorage.getItem("emp_id");

    if (!token || !empId) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const storedEmpId = localStorage.getItem("emp_id");
        if (storedEmpId) {
          setEmpId(storedEmpId);
        }

        const res = await api.get("/employee-profile");
        if (res.data.success && res.data.data) {
          setUsername(res.data.data.username || "No Name");
        } else {
          setError("Failed to fetch employee profile");
        }
      } catch (err) {
        setError("Error fetching profile");
      }
    };

    const fetchProducts = async () => {
      try {
        const response = await api.get("/get/products");
        if (response.data.success) {
          setProducts(response.data.data);
        } else {
          setError("Failed to fetch products");
        }
      } catch (err) {
        setError("Error fetching products");
      } finally {
        setLoading(false);
      }
    };

    const fetchStates = async () => {
      try {
        const res = await api.get("/get/state");
        if (res.data.success) {
          setStates(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch states", err);
      }
    };

    fetchProfile();
    fetchProducts();
    fetchStates();
  }, []);

  useEffect(() => {
    const fetchDistributors = async () => {
      if (!selectedState) return;
      try {
        const res = await api.post(`/distributor/data?state=${selectedState}`);
        if (res.data.success) {
          setDistributors(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch distributors", err);
      }
    };
    fetchDistributors();
  }, [selectedState]);

  useEffect(() => {
  if (selectedDistributor) {
    const selected = distributors.find(
      (d) => (d.firm_name || d.name) === selectedDistributor
    );
    setDistributorAddress(selected?.adresse || "");
  }
}, [selectedDistributor, distributors]);


  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const selectRole = (role) => {
    setDropdownValue(role);
    setDropdownOpen(false);
  };

  const toggleProductSelect = (product) => {
    setSelectedProducts((prevSelected) => {
      const alreadySelected = prevSelected.find((p) => p.id === product.id);
      if (alreadySelected) {
        return prevSelected.filter((p) => p.id !== product.id);
      } else {
        return [{ ...product, quantity: 1 }, ...prevSelected];
      }
    });
  };

  const removeProduct = (productId) => {
    setSelectedProducts((prevSelected) =>
      prevSelected.filter((product) => product.id !== productId)
    );
  };

  const updateQuantity = (productId, quantity) => {
    setSelectedProducts((prevSelected) =>
      prevSelected.map((product) =>
        product.id === productId
          ? { ...product, quantity: Math.max(1, Number(quantity)) }
          : product
      )
    );
  };

  const incrementQuantity = (productId) => {
    updateQuantity(
      productId,
      selectedProducts.find((p) => p.id === productId).quantity + 1
    );
  };

  const decrementQuantity = (productId) => {
    updateQuantity(
      productId,
      selectedProducts.find((p) => p.id === productId).quantity - 1
    );
  };

  const handleSubmitOrder = async () => {
    if (!empId) {
      alert("Employee ID not available. Please refresh or log in again.");
      return;
    }

    if (selectedProducts.length === 0) {
      alert("Please select at least one product.");
      return;
    }

    const productIds = selectedProducts.map((p) => String(p.id));
    const quantities = selectedProducts.map((p) => String(p.quantity));
    const prices = selectedProducts.map((p) => String(p.price));

    const payload = {
      emp_id: empId,
      customer: dropdownValue || "Unknown",
      other_customer: textInput || null,
      product_id: productIds,
      quantity: quantities,
      price: prices,
      state: selectedState,
      firm_name: selectedDistributor,
      address: distributorAddress,
    };

    try {
      const response = await api.post("/order/place", payload);
      if (response.data.success) {
        alert(
          `✅ Order placed successfully! Order ID: ${response.data.data.order_id}`
        );
        setSelectedProducts([]);
        setTextInput("");
        setDropdownValue("");
        setSelectedState("");
        setSelectedDistributor("");
        setDistributorAddress("");
      } else {
        alert("❌ Failed to place order.");
      }
    } catch (error) {
      console.error("Order API Error:", error.response?.data || error.message);
      alert("❌ An error occurred while placing the order.");
    }
  };

  const filteredProducts = showPopular
    ? products.filter((product) => product.category_id === 2)
    : products;

  return (
    <section className="meeting-section section-myorder">
      <div className="container">
        <div className="inner-content">
          <div className="left-wrapper">
            <div className="top-bar">
              <div className="img-box">
                <img src="./images/p-1.png" alt="User profile" />
              </div>
              <div className="user-name">
                <h4>{username || "Loading..."}</h4>
              </div>
            </div>

            <div className="bottom-bar">
              {/* 🔽 State Dropdown */}
              <div className="custom-dropdown">
                <select
  value={selectedState}
  onChange={(e) => setSelectedState(e.target.value)}
>
  <option value="">Select State</option>
  {states.map((state) => (
    <option key={state.state_id} value={state.state_title}>
      {state.state_title}
    </option>
  ))}
</select>

              </div>

              {/* 🔽 Distributor Dropdown */}
              <div className="custom-dropdown">
              <select
  value={selectedDistributor}
  onChange={(e) => setSelectedDistributor(e.target.value)}
  disabled={!selectedState}
>
  <option value="">Select Firm Name</option>
  {distributors.map((dist, index) => (
    <option key={index} value={dist.firm_name || dist.name}>
      {dist.firm_name || dist.name}
    </option>
  ))}
</select>

              </div>

              {/* 🔽 Address field (readonly) */}
              <div className="text-fild">
                <input
                  type="text"
                  placeholder="Address will appear here"
                  value={distributorAddress}
                  readOnly
                />
              </div>

              <div className="custom-dropdown role-select">
                <div className="custom-select-box" onClick={toggleDropdown}>
                  {dropdownValue || "Select Role"}
                  <span className="arrow">{dropdownOpen ? "▲" : "▼"}</span>
                </div>
                {dropdownOpen && (
                  <ul className="custom-options">
                    {roles.map((role) => (
                      <li
                        key={role}
                        className={role === dropdownValue ? "selected" : ""}
                        onClick={() => selectRole(role)}
                      >
                        {role}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="text-fild">
                <input
                  type="text"
                  placeholder="Enter text here"
                  value={textInput}
                  onChange={(e) => setTextInput(e.target.value)}
                />
              </div>

              <div className="button-gropup">
                <button
                  onClick={() => setShowPopular(true)}
                  className={showPopular ? "active" : ""}
                >
                  Popular Product
                </button>
                <button
                  onClick={() => setShowPopular(false)}
                  className={!showPopular ? "active" : ""}
                >
                  All Product
                </button>
              </div>

              <div className="show-product">
                <div className="top-header">
                  <h3>{showPopular ? "Popular Product" : "All Product"}</h3>
                  <button className="add-product-010">Add Product</button>
                </div>

                <div className="product-scroll">
                  {loading ? (
                    <p>Loading products...</p>
                  ) : error ? (
                    <p className="error">{error}</p>
                  ) : (
                    <div className="scroll-product-wrapper">
                      <ul className="row-product-wrapper">
                        {filteredProducts.map((product) => {
                          const isSelected = selectedProducts.find(
                            (p) => p.id === product.id
                          );
                          return (
                            <li
                              className={`main-product ${
                                isSelected ? "selected" : ""
                              }`}
                              key={product.id}
                              onClick={() => toggleProductSelect(product)}
                            >
                              <div className="product-box">
                                <img
                                  src={product.image}
                                  alt={product.name}
                                  className="product-image"
                                />
                                <h3>
                                  <strong>{product.name}</strong>
                                </h3>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                      <div className="product-datiles">
                        {[...selectedProducts].map((product) => (
                          <div
                            key={product.id}
                            className="selected-product-detail"
                          >
                            <div className="order-img">
                              <img
                                src={product.image}
                                alt={product.name}
                                className="product-image"
                              />
                            </div>
                            <div className="product-info">
                              <h3>
                                <strong>{product.name}</strong>
                              </h3>
                              <p>Code: {product.code}</p>
                              <p>Price: ₹{product.price}</p>
                              <div className="quantity-control">
                                <label>Quantity:</label>
                                <div className="qty-btns">
                                  <button
                                    onClick={() =>
                                      decrementQuantity(product.id)
                                    }
                                  >
                                    -
                                  </button>
                                  <input
                                    type="number"
                                    min="1"
                                    value={product.quantity}
                                    onChange={(e) =>
                                      updateQuantity(product.id, e.target.value)
                                    }
                                  />
                                  <button
                                    onClick={() =>
                                      incrementQuantity(product.id)
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                              <button
                                className="remove-product-btn"
                                onClick={() => removeProduct(product.id)}
                              >
                                <i className="fa-solid fa-xmark"></i>
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                      {selectedProducts.length > 0 && (
                        <button
                          className="order-place"
                          onClick={handleSubmitOrder}
                        >
                          Place Order
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Myorder;
